import CommonEN from '@intelligence/_locales/en-US/common';
import { buildDownloadDataNew } from '@intelligence/utils/commonUtils';
import { getRobloxRankSourceItemByValue } from '@intelligence/v3/pages/RobloxGameRank/config/robloxRankSourceConfig';
import { formatRobloxDeviceDownloadLabel } from '@intelligence/v3/pages/RobloxGameRank/config/robloxDeviceFilter';
import { getCountryByCode } from '@intelligence/v3/utils/region';
import {
  filterRobloxDownloadRows,
  normalizeRobloxDownloadRows,
  sortRobloxDownloadRows,
} from '@intelligence/v3/pages/RobloxGameRank/utils/sortRobloxGameRankDownloadRows';

const getStoreRankLabel = (sourceValue: string | undefined): string => {
  if (!sourceValue) {
    return '-';
  }

  const sourceItem = getRobloxRankSourceItemByValue(sourceValue);
  if (!sourceItem?.labelKey) {
    return sourceValue;
  }

  return CommonEN[sourceItem.labelKey as keyof typeof CommonEN] || sourceValue;
};

const formatSubGenre = (row: IRecord): string => {
  return row?.roblox_level_3_genre || row?.entity_info?.roblox_level_3_genre || '';
};

export const getRobloxGameRankConfig = (data: any, _params: any, allParams: any) => {
  const entityInfoMap =
    data?.$ext?.entity_info ||
    data?.ext?.entity_info ||
    data?.data?.ext?.entity_info ||
    {};
  const rawList = Array.isArray(data?.list)
    ? data.list
    : Array.isArray(data?.data?.list)
      ? data.data.list
      : [];
  const regionOptions = allParams?.regionOptions || [];
  const isDeviceShow = allParams?.device_show === 1;
  const isGenreShow = allParams?.genre_show === 1;

  const normalizedList = normalizeRobloxDownloadRows(rawList, entityInfoMap);
  const filteredList = filterRobloxDownloadRows(normalizedList, allParams);
  const sortedList = sortRobloxDownloadRows(filteredList, allParams);

  const commonSheetConfig = [
    {
      title: 'Store Rank',
      key: (item: IRecord) => getStoreRankLabel(item?.source),
    },
    {
      title: 'Date',
      key: (item: IRecord) => item?.date || '-',
    },
    {
      title: 'Game',
      key: (item: IRecord) =>
        item?.entity_name || item?.game_name || item?.game_id || '-',
    },
    {
      title: 'Country_Chinese',
      key: (item: IRecord) =>
        getCountryByCode(item?.market, regionOptions)?.country_name_ch ||
        item?.market ||
        '',
    },
    {
      title: 'Country_English',
      key: (item: IRecord) =>
        getCountryByCode(item?.market, regionOptions)?.country_name_en ||
        item?.market ||
        '',
    },
    {
      title: 'Release Date',
      key: (item: IRecord) => item?.release_time || '-',
    },
    {
      title: 'Updated Date',
      key: (item: IRecord) => item?.update_time || '-',
    },
    {
      title: 'Device',
      key: (item: IRecord) => formatRobloxDeviceDownloadLabel(item?.device),
      when: () => isDeviceShow,
    },
    {
      title: 'Main Genre',
      key: (item: IRecord) =>
        item?.roblox_sub_genre || item?.entity_info?.roblox_sub_genre || '-',
      when: () => isGenreShow,
    },
    {
      title: 'Sub Genre',
      key: (item: IRecord) => formatSubGenre(item),
      when: () => isGenreShow,
    },
    {
      title: 'Rank',
      key: (item: IRecord) => item?.rank ?? '',
    },
    {
      title: 'Change',
      key: (item: IRecord) => item?.rank_dod ?? '',
    },
  ];

  return {
    stat: {
      sheetName: 'Store Rank Details',
      style: 'normal',
      data: buildDownloadDataNew(commonSheetConfig, sortedList),
    },
  };
};
